import React from 'react'
import PropTypes from 'prop-types'
import { PageNotFound } from '@sainsburys-tech/bolt'
import { canUseDom } from '@sainsburys-tech/boltui-utils'
import AlternativesHOC from '../Alternatives/AlternativesHOC'
import { useBrandConfigContext } from '../../providers/BrandConfigContext/BrandConfigContext'
import * as Styled from './ErrorPage.styles'

const getPreviousUrl = BASE_URL => {
  if (canUseDom() && document.referrer && document.referrer.includes(BASE_URL)) {
    return document.referrer
  }
  return `//${BASE_URL}`
}

const ErrorPage = ({ failureStatus, parentPartNumber }) => {
  const { BASE_URL } = useBrandConfigContext()
  const links = [
    {
      text: 'Take me back',
      href: getPreviousUrl(BASE_URL),
      title: 'Take me back',
      handler: {}
    },
    {
      text: 'Take me back to the homepage',
      href: `//${BASE_URL}`,
      title: 'Take me home: Argos Homepage',
      handler: {}
    },
    {
      text: 'Contact us',
      href: `//${BASE_URL}/help`,
      title: 'Contact us: Argos help pages',
      handler: {}
    }
  ]

  return (
    <main itemProp='mainEntityOfPage' itemScope itemType='https://schema.org/Product' data-test='error-page'>
      <div className='container xs-row'>
        <Styled.Column className='sm-12 md-5 lg-5'>
          <PageNotFound links={links} data-test='error-page' />
          {failureStatus === 404 && <AlternativesHOC {...{ type: 'alternatives', parentPartNumber }} />}
        </Styled.Column>
      </div>
    </main>
  )
}

ErrorPage.propTypes = {
  failureStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parentPartNumber: PropTypes.string
}

ErrorPage.defaultProps = {
  failureStatus: 404,
  parentPartNumber: ''
}
export default ErrorPage
